// File: CompanyWindingUp.jsx
import React from "react";

export default function CompanyWindingUp() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Company Winding Up
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks manages voluntary and legal company winding-up processes.
          </p>
          <p className="text-gray-700">
            Complete company liquidation services including STK-2/STK-7 filings, board resolutions, creditor settlements, NCLT proceedings, asset distribution, and final dissolution under Companies Act 2013.
          </p>
        </div>

        {/* Right: Image (COMPANY WINDING UP SPECIFIC) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/163510/business-money-finance-economy-163510.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Company winding up and liquidation services by Hawkins & Brooks"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation for seamless company winding-up process.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Financial statements (last 2 years)</li>
                <li>Board resolutions & affidavits</li>
                <li>Indemnity bond & solvency declaration</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Legal and procedural accuracy ensuring smooth company dissolution process.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Companies Act Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of Companies Act 2013 Chapter XX requirements including voluntary liquidation (STK-2), fast-track (STK-7), members'/creditors' voluntary winding up, NCLT procedures, and strike-off compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Procedural Accuracy
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise MCA filings (STK-2 within 270 days NIL returns), insolvency professional coordination, creditor settlements, asset distribution statements, final dissolution certificates, and penalty avoidance through procedural compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Liquidation
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service winding up from board resolutions through STK forms preparation, creditor meetings, asset liquidation, final accounts preparation, NCLT filings, ROC strike-off, statutory clearances, and closure certificates.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
